import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { _className, LL_H_C, LL_V_L, ModuleFE_Utils, TS_TextArea } from '@nu-art/thunderstorm-frontend/index';
import './Component_ExpressionDescription.scss';
import { AccessLevel, ModuleFE_PermissionsAssert } from '@nu-art/permissions-frontend/modules/ModuleFE_PermissionsAssert';
import { ModuleFE_Expression } from '../../../../../../../_entity/expression/index.js';
import { OrgAccessLevel } from '@app/hcs-shared';
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/editable-item';
export class Component_ExpressionDescription extends TS_EditableItemComponent {
    canEdit = () => {
        if (!this.state.editable.item._id)
            return false;
        const collectionAccessLevel = ModuleFE_PermissionsAssert.getAccessLevel(ModuleFE_Expression.permissions.collection.edit);
        const orgAccessLevelResolver = ModuleFE_Utils.getProcessor('assert-org-permission');
        const orgAccessLevel = orgAccessLevelResolver(this.state.editable.item);
        return orgAccessLevel !== OrgAccessLevel.write || collectionAccessLevel !== AccessLevel.HasAccess;
    };
    renderTextLimit = () => {
        const overTheLimit = this.getDescription().length > 10000;
        const className = _className('description-length', overTheLimit && 'over-limit');
        return _jsxs(LL_H_C, { className: 'length-info-container', children: [_jsxs("div", { className: className, children: [this.getDescription().length, "/10000"] }), overTheLimit && _jsx("div", { className: className, children: "Description too long!" })] });
    };
    render() {
        const className = _className(this.getDescription().length > 10000 && 'over-limit');
        return _jsxs(LL_V_L, { className: 'expression-description', children: [_jsx(TS_TextArea, { className: className, width: '100%', disabled: this.canEdit(), type: 'text', value: this.getDescription() || '', onBlur: async (description) => await this.props.editable.updateObj({ description: description }), onChange: async (description) => await this.props.editable.updateObj({ description: description }) }), this.renderTextLimit()] });
    }
    getDescription() {
        return this.props.editable.item.description || '';
    }
}
//# sourceMappingURL=Component_ExpressionDescription.js.map